// src/components/Footer.js
import React from 'react';
import './Footer.css';
import logo from '../imgs/dishalogo.png'; // सही path रखो

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        {/* Logo + Company Name */}
        <div className="footer-logo">
          <img src={logo} alt="Disha Machinery Logo" width="100" height="95" />
          <p>DISHA TECHNOLOGIES</p>
          <p>DISHA MACHINERY & PROJECTS PVT LTD</p>
          <p>Deals in:-+Used Injection Moulding Machine, Auxiliary Equipments, Robot, PLC & Servo Motor Machine Upgradation</p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="Home">Home</a></li>
            <li><a href="Eb-seriesextrusion">Blow Moulding</a></li>
            <li><a href="Plasticbackspray">Solutions</a></li>
            <li><a href="Cavitypetprefor">News</a></li>
          </ul>
          
        </div>

        {/* Contact Details */}
        <div className="footer-contact">
          <h4>Contact Us</h4>
          <p><strong>Corporate Office:</strong> E-303, 1st Floor, Patel Garden, Opp. NSUT, Near Surya Green Banquet Hall, Dwarka, Delhi-110078</p>
          <p><strong>Factory:</strong> Plot No. 76/20, Ground Floor, Swaran Park Industrial Area, Mundka, New Delhi-110041</p>
          <p><strong>Email:</strong> md@dishamachines.com, dishamachines@gmail.com</p>
          <p><strong>Website:</strong> www.dishamachine.com, www.dishamachines.com</p>
          <p><strong>Phone:</strong> +91-11-44463786, M-9910033517</p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Disha Machinery. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
